module.exports = __webpack_public_path__ + "static/media/Sara_Cerqueira.cafecfff.jpeg";